import styled from 'styled-components';
import { CustomThemeToken } from '@/theme/theme.utils';
import { breakpoints } from '@/utils/util-breakpoints';

export const AdditionalInformationCardContainer = styled.div<{ theme: { token: CustomThemeToken } }>`
  background: ${({ theme: { token } }) => token.colorFillQuaternary};
  margin-bottom: ${({ theme: { token } }) => token.margin}px;
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;

  .collapse-header {
    display: flex;
    justify-content: space-between;
  }

  .spec-content {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.margin}px;
  }

  .top-section {
    .basic-info-row {
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.margin}px;
      flex-wrap: wrap;

      .metric-wrapper {
        display: flex;
        align-items: center;
        min-width: 0;
        
        &:not(:has(.metric-link)) {
          flex: 0 0 auto;
          min-width: max-content;
        }
        
        &:has(.metric-link) {
          flex: 1 1 0;
          min-width: 20ch;
        }
      }

      .divider {
        width: 1px;
        height: 20px;
        background: ${({ theme: { token } }) => token.colorBorderSecondary};
        flex-shrink: 0;
        order: 0;
      }
      
      .metric-wrapper:nth-child(n+4) ~ .divider {
        display: none;
      }
    }
  }

  .metrics-grid {
    display: flex;
    gap: ${({ theme: { token } }) => token.marginLG}px;
    flex-wrap: wrap;
  }

  .metric-row {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginXXS}px;

    &.flow-metric,
    &.power-metric {
      min-width: 69px;
    }

    .metric-label {
      color: ${({ theme: { token } }) => token.colorTextTertiary};
    }

    .metric-value-container {
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.marginXXS}px;

      .metric-value {
        font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        line-height: ${({ theme: { token } }) => token.lineHeightHeading4};
      }

      .metric-unit {
        color: ${({ theme: { token } }) => token.colorTextTertiary};
      }
      .metric-link {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .top-section .metric-row {
    flex-direction: row;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;

    &:has(.metric-link) {
      min-width: 100px;
      flex: 1;

      .metric-value-container {
        min-width: 0;
        flex: 1;
      }
    }

    .metric-value {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }

    @media (max-width: ${breakpoints.md - 1}px) {
      flex-direction: column;
      align-items: flex-start;
      gap: ${({ theme: { token } }) => token.marginXXS}px;

      .metric-label {
        margin-bottom: 0;
      }

      .metric-value-container {
        width: 100%;
        max-width: 100%;
        
        .metric-link {
          max-width: 100%;
          display: block;
        }
      }
    }
  }

  .ant-col[flex="1"] .metric-row {
    width: 100%;
    
    &:has(.metric-link) {
      min-width: 100px;
      flex: 1;

      .metric-value-container {
        min-width: 0;
        flex: 1;
      }
    }
  }
`;
